const environment = {
    apiAuthAgentUrl: "https://api-gateway-prod.cyberprotect.cloud/auth",
    apiAuthCustomerUrl: "https://api-gateway-prod.cyberprotect.cloud/auth-customer",
}

export default environment;
